import { render, staticRenderFns } from "./NewProperties.vue?vue&type=template&id=415eaf86&scoped=true&"
import script from "./NewProperties.vue?vue&type=script&lang=ts&"
export * from "./NewProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415eaf86",
  null
  
)

export default component.exports